export const log = (type, ...context) => {
    // tslint:disable-next-line:no-console
    console.log(type, context);
};
//# sourceMappingURL=Log.js.map